import { FormStrategiesObj } from "@/common/types";
import diaFormStrategy from "./diaForm.strategy";
import iptFormStrategy from "./iptForm.strategy";
import biaFormStrategy from "./biaForm.strategy";
import wiaFormStrategy from "./wiaForm.strategy";
import eplFormStrategy from "./eplForm.strategy";
import hardwareFormStrategy from "./hardwareForm.strategy";
import crossConnectFormStrategy from "./crossConnectForm.strategy";
import fieldsFormStrategy from "./fieldsForm.strategy";
import rackAndSpaceFormStrategy from "./rackAdnSpaceForm.strategy";
import ipAddressFormStrategy from "./ipAddressForm.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";

const formsStrategy: FormStrategiesObj = {
  [QUOTES_TYPE[0]]: diaFormStrategy,
  [QUOTES_TYPE[1]]: iptFormStrategy,
  [QUOTES_TYPE[2]]: biaFormStrategy,
  [QUOTES_TYPE[3]]: wiaFormStrategy,
  [QUOTES_TYPE[4]]: ipAddressFormStrategy,
  [QUOTES_TYPE[5]]: eplFormStrategy,
  [QUOTES_TYPE[6]]: eplFormStrategy,
  [QUOTES_TYPE[7]]: hardwareFormStrategy,
  [QUOTES_TYPE[8]]: fieldsFormStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceFormStrategy,
  [QUOTES_TYPE[10]]:crossConnectFormStrategy  ,
};

export default formsStrategy;
